<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>工资汇总使用说明:<br>
					<span>1、查询范围已经完成人事核对的</span><br>
					<span>2、查询关键字:单号、部门、人员、日期范围。<span class="red">默认本月</span></span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '工资单汇总',
					"control": "salaryallsum",
					"isTwo": "1",
					"sel_action_flag": "", //更多查询
					"isFileMain": "1",
					"isShowEdit":"0",
					"sel_action": 'exp_kq_salary_all',
					"upd_action": 'exp15_kq_salary_all',
					"step": '0',
					"detail_part": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": 'kq',
					"p2": 'salary',
					"p3": '',
					"parm_sel": [{
							"name": "账号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1",
							"note": "按账号查询"
						},
						// {
						// 	"name": "部门",
						// 	"val": "",
						// 	"key": "d_name",
						// 	"type": "selectmore",
						// 	"class": "long1",
						// 	"sel_action": "_base_dep",
						// 	"sel_name": "",
						// 	"sel": "2"
						// },
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_roleuser",
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "开始月份",
							"val": '',
							"key": "s_month",
							"type": "month",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "截止月份",
							"val": '',
							"key": "e_month",
							"type": "month",
							"class": "long1",
							"sel": "4"
						}
					],
					"parm": [],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "角色"
						},
						{
							"name": "人员姓名"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						// {
						// 	"name": "基本工资"
						// },
						// {
						// 	"name": "岗位绩效"
						// },
						// {
						// 	"name": "交通补贴"
						// },
						// {
						// 	"name": "餐补"
						// },
						// {
						// 	"name": "话补"
						// },
						// {
						// 	"name": "社保补贴"
						// },
						// {
						// 	"name": "安全奖"
						// },
						// {
						// 	"name": "工龄工资"
						// },
						// {
						// 	"name": "运输工资"
						// },
						{
							"name": "应发总额"
						},
						{
							"name": "计薪基数"
						},
						{
							"name": "应工作天数"
						},
						{
							"name": "实际工作天数"
						},
						{
							"name": "缺勤工作天数"
						},
						{
							"name": "全勤奖励"
						},
						{
							"name": "缺勤罚款"
						},
						{
							"name": "打卡"
						},
						{
							"name": "日志"
						},

						{
							"name": "预支|借款"
						},
						{
							"name": "罚款"
						},
						{
							"name": "违章"
						},


						{
							"name": "奖励"
						},
						{
							"name": "社保"
						},
						{
							"name": "住房公积金"
						},
						{
							"name": "个人所得税"
						},
						{
							"name": "绩效"
						},
						{
							"name": "其他"
						},
						{
							"name": "扣除考勤应发"
						},
						{
							"name": "本月实发"
						},
						{
							"name": "临时发放"
						},
						{
							"name": "剩余发放"
						},
						{
							"name": "计算说明"
						},
						
						// {
						// 	"name": "奖罚明细"
						// },
						// {
						// 	"name": "录入人"
						// },
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						// {
						// 	"name": "更新时间"
						// }
						{
							"name": "备注"
						}
					],
					"d_parm": [],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "审核角色"
						},
						{
							"name": "审核人"
						},
						{
							"name": "审核日期"
						},
						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						}
					]
				});



				// console.log(this.$refs);
				// this.$refs.mybase.load_data();
				// 解决偶尔第一次没有加载完成时再次 调用一下
				// var that = this;
				// this.$nextTick(function() {
				// 	that.$refs.mybase.load_data();
				// });

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>